import { UseFormSetError } from 'react-hook-form';

type AllowedErrors = Record<string, Record<string, string>>;

export function tryApiContextValidationRHF(
  errorDescription: Record<string, string>,
  setError: UseFormSetError<any>,
  allowedErrors: AllowedErrors
): boolean {
  if (Object.keys(errorDescription).length === 0) {
    console.error('tryApiContextValidationRHF: empty errorDescription');
    return false;
  }

  let hasError = false;

  for (const field in errorDescription) {
    const errorMessage = errorDescription[field];
    const uiMessage = allowedErrors[field]?.[errorMessage];

    if (!uiMessage) {
      console.error(
        'tryApiContextValidationRHF:',
        errorDescription,
        allowedErrors,
        field,
        errorMessage,
        uiMessage
      );
      continue;
    }

    setError(field, { type: 'manual', message: uiMessage });
    hasError = true;
  }

  return hasError;
}
